import { ReduxUser } from 'app/redux/ReduxInterfaces'
import { AC_MEMBER, SC_MEMBER } from './committeesConstants'

export const checkIsMemberForCommittee = (
  item,
  user: ReduxUser,
  committee: 'SC' | 'AC'
): boolean => {
  // const renderInfo = committeeInfo[committee]
  const isSelectionCommitteePage = committee === 'SC'
  const isAllocationCommitteePage = committee === 'AC'

  let hasAccess = true
  if (isSelectionCommitteePage) {
    hasAccess = item?.teamMembers?.some(
      (member) =>
        member.userId === user.userId &&
            member.teamMemberRole === SC_MEMBER
    )
  } else if (isAllocationCommitteePage) {
    hasAccess = item?.teamMembers?.some(
      (member) =>
        member.userId === user.userId &&
            member.teamMemberRole === AC_MEMBER
    )
  }
  return hasAccess
}
